import { makeStyles } from '@mui/styles';

export const pslstyle = (platform) => {
    let s = makeStyles(theme => ({
        tf: {
            fontSize: '10px',
            '& label.Mui-focused': {
                color: platform==='accreditor'?theme.palette.primary.business:theme.palette.primary.personal,
            },
            '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                    borderColor: platform==='accreditor'?theme.palette.primary.business:theme.palette.primary.personal,
                },
            }
        },
        border: {
            '& .MuiOutlinedInput-root': {
                borderRadius: '10px'
            }
        },
        button: {
            borderRadius: '8px',
            fontSize: '15px',
            shadow: 'none',
            boxShadow: 'none',
            "&:disabled": {
                backgroundColor: 'rgba(4, 117, 126, 50%)',
                color: "#FFF"
            }
        },
        fb_button: {
            backgroundColor: '#167EE7',
            fontSize: '15px',
            shadow: 'none',
            boxShadow: 'none',
            borderRadius: '12px',
            '&:hover': {
                backgroundColor: '#0c59b0',
            }
        },
        google_button: {
            backgroundColor: '#DB4437',
            fontSize: '15px',
            shadow: 'none',
            boxShadow: 'none',
            borderRadius: '12px',
            '&:hover': {
                backgroundColor: '#a3281d',
            }
        }
    }))

    return s()
}